export const level3Data = {
      catImage:'/images/cats/meowgame.png',
    backgroundImage: '/images/backgrounds/level3.JPG',
   nextLevel: '/end',
  catPosition: {
    x: '65%', 
    y: '25%'  
  },
};
export default level3Data;